/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S6_Li2_BeforeInputs */

const tr_onbilgi_s6_li2_before = /** @type {(inputs: Onbilgi_S6_Li2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri, yenilemek isterse Platform içi`)
};

const en_onbilgi_s6_li2_before = /** @type {(inputs: Onbilgi_S6_Li2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customers who want to renew pay for the new term via the`)
};

const de_onbilgi_s6_li2_before = /** @type {(inputs: Onbilgi_S6_Li2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchte der Kunde verlängern, zahlt er für die neue Laufzeit über die Seite`)
};

const ru_onbilgi_s6_li2_before = /** @type {(inputs: Onbilgi_S6_Li2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чтобы продлить подписку, Клиент оплачивает новый срок через страницу`)
};

/**
* | output |
* | --- |
* | "Customers who want to renew pay for the new term via the" |
*
* @param {Onbilgi_S6_Li2_BeforeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s6_li2_before = /** @type {((inputs?: Onbilgi_S6_Li2_BeforeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S6_Li2_BeforeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s6_li2_before(inputs)
	if (locale === "de") return de_onbilgi_s6_li2_before(inputs)
	if (locale === "ru") return ru_onbilgi_s6_li2_before(inputs)
	return tr_onbilgi_s6_li2_before(inputs)
});